/**
 * @summary Primary menu enhancer.
 */

import { h, render } from 'preact';
import MainMenu from './components/MainMenu';
import parseHTML from './parse-html';

/**
 * @summary Parses HTML structure into a menu tree structure.
 *
 * @param {HTMLUListElement} listElement The root menu list element.
 * @returns {Object[]} The structure of the menu.
 */
function parseMenu( listElement ) {
	return Array.from( listElement.children )
		.map( listItem => {
			const link = listItem.querySelector( 'a' );
			const subMenu = listItem.querySelector( 'ul' );

			return {
				title: link.textContent,
				url: link.href,
				children: subMenu ? parseMenu( subMenu ) : [],
				activeTrail: link.classList.contains( 'is-active-trail' )
			};
		});
}

const root = document.getElementById( 'js-main-menu' );
const menuMarkup = root.querySelector( '.c-primary-menu' );

new Promise( resolve => resolve( parseMenu( parseHTML( menuMarkup.textContent )[0]) ) )
	.then( menuTree => {
		menuMarkup.parentElement.removeChild( menuMarkup );
		render( <MainMenu menuTree={menuTree} localizedStrings={wp_data.loweMenuStrings}/>, root );
	});



// WEBPACK FOOTER //
// ./src/js/primary-menu.js